export default class Subject{
  constructor(){
    this.observerList = []
    this.state = ''
  }

  add(obj){
    return this.observerList.push(obj)
  }

  notify(type) {
    this.observerList.forEach( observer => {
      observer(type)
    })
  }

  getState() {
    return this.state
  }
}


/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/auth/models/subject.js
 **/